import { defineMessages } from 'react-intl';

export default defineMessages({
  asset: 'Asset',
  yourWalletBalance: 'Your wallet balance',
  yourBalanceinAave: 'Your balance in SSAP',
  APY: 'APY',

  dividerTitle: 'To make a deposit, transfer any of these assets to your wallet.',
  connectWallet: 'To make a deposit, please connect a wallet',
});
